/**************************************
 * STORAGE KEYS
 *************************************/
const WISHLIST_KEY = "guest_wishlist";
const PENDING_PRODUCT_KEY = "pending_wishlist_product";

/**************************************
 * CORE HELPERS
 *************************************/
function getWishlist() {
  return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || {};
}

function saveWishlist(data) {
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(data));
}

/**************************************
 * ADD TO WISHLIST (CORE LOGIC)
 *************************************/
function addToWishlist(product) {
  let wishlist = getWishlist();

  if (!wishlist[product.category]) {
    wishlist[product.category] = {};
  }

  if (!wishlist[product.category][product.type]) {
    wishlist[product.category][product.type] = [];
  }

  const exists = wishlist[product.category][product.type].find(
    item => item.id == product.id
  );

  if (!exists) {
    wishlist[product.category][product.type].push(product);
  }

  saveWishlist(wishlist);
  alert("Added to wishlist");
}

/**************************************
 * LOGIN POPUP (PLACEHOLDER)
 *************************************/
function openWishlistLoginPopup() {
  alert("Please login to continue"); // replace later
}

/**************************************
 * ADD TO WISHLIST CLICK HANDLER (FIXED)
 *************************************/
document.addEventListener(
  "click",
  function (e) {
    const btn = e.target.closest(".add-to-wishlist");
    if (!btn) return;

    // 🚨 REQUIRED FOR ELLA THEME
    e.preventDefault();
    e.stopImmediatePropagation();

    const product = {
      id: btn.dataset.id,
      title: btn.dataset.title,
      image: btn.dataset.image,
      category: btn.dataset.category || "Uncategorized",
      type: btn.dataset.type || "Other",
      qty: 1
    };

    if (window.WISHLIST_CONFIG && window.WISHLIST_CONFIG.isLoggedIn) {
      addToWishlist(product);
    } else {
      localStorage.setItem(PENDING_PRODUCT_KEY, JSON.stringify(product));
      openWishlistLoginPopup();
    }
  },
  true // 👈 CRITICAL (CAPTURE PHASE)
);
